export default __webpack_public_path__ + "static/media/ai-image-generator-screenshot-04.6db4ec1e.png";